import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "./store/store";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import "./Components.css";
import "./Pages.css";
import "./styles/design-system.css";
import "./components/flashbackSections/base/tokens.css";
// import "./index.css";

if (process.env.NODE_ENV === "development") {
  // Dev-only observability hook (no-op path in production builds).
  // eslint-disable-next-line global-require
  const { monitorMemory } = require("./utils/performanceMonitor");
  monitorMemory();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
